<template>
	<payHeader :bgStatus="bgStatus"></payHeader>
	<div class="user-repwd">
		<div class="container">
			<div class="head">
				<h1>{{bindType == 'qq' ? 'QQ绑定':'微信绑定'}}</h1>
			</div>
			<div class="tips" style="text-align: right;">没有蓝队云账号？<router-link to="/register">去注册</router-link></div>
			<el-form :rules="rules" ref="ruleFormRef" :model="groupForm" status-icon inline-message>
				<el-form-item prop="username">
					<span class="label">用户名</span>
					<el-input v-model="groupForm.username" placeholder="用户名" autocomplete="off" />
				</el-form-item>
				<el-form-item prop="password">
					<span class="label">登录密码</span>
					<el-input v-model="groupForm.password" type="password" show-password placeholder="登录密码" autocomplete="off" />
				</el-form-item>
				<el-form-item>
					<el-button type="primary" class="submit" @click="submitForm(ruleFormRef)">立即绑定</el-button>
				</el-form-item>
			</el-form>
		</div>
	</div>
	<payFooter></payFooter>
</template>

<script setup>
	import { ref,reactive,inject,onMounted} from 'vue';
	import { useRouter } from 'vue-router';
	import { quicklogin } from '@/api/home';
	import { payHeader,payFooter } from 'landui-ui';
	
	const bgStatus = ref(true);
	const domain = inject('domain');
	const router = useRouter();
	const bindType = ref('');
	const openId = ref('');
	const unionId = ref('');
	const ruleFormRef = ref(null);
	const groupForm = ref({username:'',password:''});
	const rules = reactive({
		username: [
			{ required: true, message: '', trigger: 'blur' }
		],
		password: [
			{ required: true, message: '', trigger: 'blur' }
		]
	});


	const submitForm = () => {
		if (!ruleFormRef.value) return;
		ruleFormRef.value.validate((valid) => {
			if (valid) {
				groupForm.value.bind_type = bindType.value;
				groupForm.value.open_id = openId.value;
				groupForm.value.union_id = unionId.value;
				groupForm.value.bind_action = 'bind';
				const param = groupForm.value;
				quicklogin(param).then((res) => {
					if(res.code === 200){
						window.location.href = domain+"/user";
					}
				})
			} else {
			  return false;
			}
		});
	};
	
	onMounted(() => {
		if(router.currentRoute.value.query){
			bindType.value = router.currentRoute.value.query.type;
			openId.value = router.currentRoute.value.query.open_id;
			unionId.value = router.currentRoute.value.query.union_id;
		}
	});
	
</script>

<style lang="scss">
	.user-repwd{
		.el-form{
			width: 380px; 
			margin: 80px auto 0;
			.el-form-item{
				position: relative;
				.el-input{
					width: 100% !important;
					--el-input-height:45px;
				}
				.el-input__suffix{margin-right: 5px;}
				.el-input__inner{padding-left: 100px;}
				.label{
					position: absolute;
					left: 0;
					top: 0;
					bottom: 0;
					z-index: 1;
					font-size: 13px;
					color: #999999;
					width: 90px;
					border-right: 1px solid #ddd;
					text-align: center;
					line-height: 45px;
				}
			}
			.other{
				overflow: hidden;
				margin-top:10px;
				span{cursor: pointer;color: #015bfe;}
			}
		}
		
	}
	
</style>